import { useRef, useLayoutEffect, useState } from "react";

const Timeline = ({ events }: any) => {
  const [boxWidths, setBoxWidths] = useState<any>({});
  const [measurementComplete, setMeasurementComplete] = useState(false);
  const boxRefs = useRef<any>({});
  // const events = [
  //   {
  //     title: "Today",
  //     year: 2024,
  //   },
  //   {
  //     title: "Emergency Fund",
  //     year: 2025,
  //   },
  //   {
  //     id: 3,
  //     title: "Buy House",
  //     year: 2027,
  //   },
  //   {
  //     id: 4,
  //     title: "Max 401k",
  //     year: 2030,
  //   },
  //   {
  //     id: 5,
  //     title: "End of plan",
  //     year: 2055,
  //   },
  // ];

  const circleSpacing = 180;
  const height = 200;
  const margin = { top: 50, right: 150, bottom: 50, left: 100 };
  const width =
    margin.left + margin.right + (events.length - 1) * circleSpacing;
  const timelineY = height / 2;

  useLayoutEffect(() => {
    const newBoxWidths: any = {};
    Object.keys(boxRefs.current).forEach((key) => {
      if (boxRefs.current[key]) {
        newBoxWidths[key] = boxRefs.current[key].offsetWidth;
      }
    });
    setBoxWidths(newBoxWidths);
    setMeasurementComplete(true);
  }, [events]);

  return (
    <div className=" p-4 relative">
      <svg width={width} height={height} className="">
        {/* Timeline line */}
        <line
          x1={margin.left}
          y1={timelineY}
          x2={width - margin.right}
          y2={timelineY}
          stroke="#787777"
          strokeWidth="2"
        />

        {events.map((event: any, index: any) => {
          const x = margin.left + index * circleSpacing;
          const isFirst = index === 0;
          const isLast = index === events.length - 1;
          const isEven = 1; //index % 2 === 0;
          const lineY = isEven ? timelineY - 8 : timelineY + 8;

          return (
            <g key={event.id}>
              {/* Circle */}
              <circle
                cx={x}
                cy={timelineY}
                r="8"
                fill="currentColor"
                className="text-main-orange shadow-lg"
                stroke="#fff"
                strokeWidth="2"
              />

              {/* Year text below all circles */}
              <text
                x={x}
                y={timelineY + 25}
                textAnchor="middle"
                className="text-sm"
                fill="#6B7280"
              >
                {event.year}
              </text>

              {/* Start/End text or connector line for boxes */}
              {isFirst ? (
                <text
                  x={x - 15}
                  y={timelineY + 3}
                  textAnchor="end"
                  className="text-sm font-semibold"
                  fill="#374151"
                >
                  {event.title}
                </text>
              ) : isLast ? (
                <text
                  x={x + 15}
                  y={timelineY + 3}
                  textAnchor="start"
                  className="text-sm font-semibold"
                  fill="#374151"
                >
                  {event.title}
                </text>
              ) : (
                <line
                  x1={x}
                  y1={lineY}
                  x2={x}
                  y2={isEven ? timelineY - 40 : timelineY + 40}
                  stroke="#6B7280"
                  strokeWidth="1"
                  strokeDasharray="3,3"
                />
              )}
            </g>
          );
        })}
      </svg>

      {/* HTML boxes */}
      {events.map((event: any, index: any) => {
        const x = margin.left + index * circleSpacing;
        const isFirst = index === 0;
        const isLast = index === events.length - 1;
        const isEven = 1; //index % 2 === 0;
        const boxY = isEven ? timelineY - 70 : timelineY + 60;

        if (isFirst || isLast) return null;

        return (
          <div
            key={`box-${event.id}`}
            ref={(el) => (boxRefs.current[event.id] = el) as any}
            className="absolute bg-gray-100 border border-gray-300 rounded p-2 text-[14px]"
            style={{
              left: measurementComplete ? x - boxWidths[event.id] / 2 + 14 : 0,
              top: boxY,
              visibility: measurementComplete ? "visible" : "hidden",
            }}
          >
            <div className="font-semibold text-gray-700">{event.title}</div>
            <div className="text-gray-500">{event.subtitle}</div>
          </div>
        );
      })}
    </div>
  );
};

export default Timeline;
